var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgVuesaxBoldAirplane(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "m15.379 8.619-1.04-.44a.585.585 0 0 1-.3-.47v-3.06c0-.96-.71-2.1-1.57-2.54-.3-.15-.66-.15-.96 0-.85.44-1.56 1.59-1.56 2.55v3.06c0 .18-.14.39-.3.47l-5.7 2.45c-.63.26-1.14 1.05-1.14 1.73v1.32c0 .85.64 1.27 1.43.93l5.01-2.16c.39-.17.71.04.71.47v2.91c0 .23-.13.56-.29.72l-2.32 2.33c-.24.24-.35.71-.24 1.05l.45 1.36c.18.59.85.87 1.4.59l2.38-2c.36-.31.95-.31 1.31 0l2.38 2c.55.27 1.22 0 1.42-.59l.45-1.36c.11-.33 0-.81-.24-1.05l-2.32-2.33c-.17-.16-.3-.49-.3-.72v-2.91c0-.43.31-.63.71-.47l5.01 2.16c.79.34 1.43-.08 1.43-.93v-1.32c0-.68-.51-1.47-1.14-1.74l-4.67-2.01z",
    fill: "{props.color}",
    fillRule: "nonzero"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgVuesaxBoldAirplane);
export default __webpack_public_path__ + "static/media/vuesax-bold-airplane.8ed0c6580d13ec7bb4ee1ca1b101b3e7.svg";
export { ForwardRef as ReactComponent };